import { isEqual } from 'lodash'

import { PlaytesterV2State } from 'app-redux/playtesterV2/types'

const sharableFields: (keyof Partial<PlaytesterV2State>)[] = [
  // Only ever updates when we add a new card/ custom card from outside the game
  'allCards',

  // Zones
  'battlefield',
  'hand',
  'library',
  'sideboard',
  'graveyard',
  'exile',
  'commandZone',
  'attractions',
  'junkyard',
  'planes',

  // Coordinates (this is a special case)
  'cardCoordinates',

  // Action options
  'selected',
  'showPopoutHand',
  'showOverlaysInPopout',

  // Overlays
  'peeking',
  'searching',
  'cardSearch',
  'allTokensOverlay',
  'randomGeneratorOverlay',
  'randomGeneratedValues',
  'generatingRandomValue',
  'openingHandOverlay',
  'customCardCreationOverlay',
  'stackDeckOverlay',
  'searchOverlaySearchValue',

  // Counters
  'lifeTotal',
  'lifeTotal2',
  'commanderDamangeOne',
  'commanderDamangeTwo',
  'commanderDamangeThree',
  'commanderDamangeFour',

  'turnCounter',
  'infectDamage',
  'experiance',

  'energy',
  'whiteMana',
  'blueMana',
  'blackMana',
  'redMana',
  'greenMana',
  'colorlessMana',

  // User settings
  'playmatColor',
  'playmatColorExtendsToLowerThird',
  'playmatUrl',
  'sleevesColor',
  'sleevesUrl',

  // Card zoomer
  'globalCardTransform',
]

export const generateSharablePlaytesterState = (
  partialPlaytesterState: Partial<PlaytesterV2State>,
  existingPlaytesterState?: PlaytesterV2State,
): Partial<PlaytesterV2State> | null => {
  // @ts-ignore
  const alteredFields: (keyof PlaytesterV2State)[] = Object.keys(partialPlaytesterState)
  const cacheableInfo = alteredFields.reduce((acc, field) => {
    if (!sharableFields.includes(field)) return acc

    // Skip if equal to the previous state's value
    // Prevents from oversending messages
    if (existingPlaytesterState && isEqual(partialPlaytesterState[field], existingPlaytesterState[field])) return acc

    // @ts-ignore
    acc[`${field}`] = partialPlaytesterState[field]

    return acc
  }, {} as Partial<PlaytesterV2State>)

  if (!Object.keys(cacheableInfo).length) return null // skip writting to local storage unless there's anything new to write

  return cacheableInfo
}

// export const cleanupSharedPlaytesterState = (partialPlaytesterState: Partial<PlaytesterV2State>): Partial<PlaytesterV2State> => {
//   if (!partialPlaytesterState.cardCoordinates)

//   const currentCardCoordinates = store.getState().playtesterV2.cardCoordinates

//   return { ...partialPlaytesterState, }
// }
